import Vue from 'vue'
import Vuex from 'vuex'

import { mapModules } from '@/helpers/store'
import auth from './auth'
import feedbacks from './feedbacks'
import dashboard from './dashboard'
import feeds from './feeds'
import integrations from './integrations'
import kudos from './kudos'
import messages from './messages'
import priorities from './priorities'
import profiles from './profiles'
import signup from './signup'
import teams from './teams'
import workspaces from './workspaces'

Vue.use(Vuex)

function modules(api) {
  return mapModules({
    auth,
    feedbacks,
    dashboard,
    feeds,
    integrations,
    kudos,
    messages,
    priorities,
    profiles,
    signup,
    teams,
    workspaces
  }, api)
}

export default api => {
  return new Vuex.Store({
    modules: modules(api)
  })
}
